import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import { markBootStage } from "@is/utils/bootCrumbs";
import { toCamelCase } from "@is/utils/string";

import cs from "./translations/cs.json";
import da from "./translations/da.json";
import de from "./translations/de.json";
import en from "./translations/en.json";
import es from "./translations/es.json";
import fi from "./translations/fi.json";
import fr from "./translations/fr.json";
import hr from "./translations/hr.json";
import it from "./translations/it.json";
import nl from "./translations/nl.json";
import pl from "./translations/pl.json";
import pt from "./translations/pt.json";
import ro from "./translations/ro.json";
import sl from "./translations/sl.json";
import sv from "./translations/sv.json";

const formatNamespaces = (translations) => {
  const updatedTranslations = {};

  for (const [key, value] of Object.entries(translations)) {
    updatedTranslations[toCamelCase(key)] = value;
  }

  return updatedTranslations;
};

export const resources = {
  da: formatNamespaces(da),
  de: formatNamespaces(de),
  en: formatNamespaces(en),
  sv: formatNamespaces(sv),
  es: formatNamespaces(es),
  fi: formatNamespaces(fi),
  fr: formatNamespaces(fr),
  hr: formatNamespaces(hr),
  it: formatNamespaces(it),
  nl: formatNamespaces(nl),
  pt: formatNamespaces(pt),
  sl: formatNamespaces(sl),
  cs: formatNamespaces(cs),
  pl: formatNamespaces(pl),
  ro: formatNamespaces(ro),
};

i18next.use(initReactI18next).init({
  fallbackLng: "en",
  debug: false,
  resources,
});
markBootStage("i18n-initialized");
